import React from 'react';
import { Redirect, Route, withRouter } from 'react-router-dom';
import Overview from './Overview/Overview';
import MasterSchedule from './MasterSchedule/MasterSchedule';
import Sports from './Sports/Sports';
import EditSports from './Sports/EditSports/EditSports';
import Classifieds from './Classifieds/Classifieds';
import IndvRegistrations from './IndividualRegistrations/IndvRegistrations';
import League from './Overview/League/league';
import ViewChampions from './Overview/League/ViewChampions/ViewChampions';
import LeagueChampion from './Overview/League/ViewChampions/LeagueChampion/LeagueChampion';
import LeagueGroups from './Overview/LeagueGroups/LeagueGroups';
import TeamInfo from './Overview/LeagueGroups/TeamInfo';
import AddPlayer from './Overview/LeagueGroups/Teams/AddPlayer';
import { pageTransitions, transitionDuration } from '../../../../Util/PageTransitions';
import CreateSchedule from './Overview/CreateSchedule/CreateSchedule';
import LevelOfPlay from '../ToolsAndSettings/Orders/Components/LevelOfPlay/LevelOfPlay';
import SmsSettings from './Overview/LeagueGroups/LeagueSettings/SmsSettings/SmsSettings';

function Leagues(props) {
  return <>
    <div className="outer-wrapper">
      <div className='user-wrapper leagueUsers-wrapper' initial={pageTransitions.initial} animate={pageTransitions.in} exit={pageTransitions.out} transition={{ duration: transitionDuration }}>
        <Route path={`${props.match.path}`} exact>
          <Redirect to={{
            pathname: `${props.location.pathname}/overview`,
            state: props.location.state,
            search: props.location.search,
          }} />
        </Route>
        <Route path={`${props.match.path}/overview`}>
          <Overview />
        </Route>
        <Route path={`${props.match.path}/master-schedule`}>
          <MasterSchedule />
        </Route>
        <Route path={`${props.match.path}/sports`} exact>
          <Sports />
        </Route>
        <Route path={`${props.match.path}/sports/edit-sports`} exact>
          <EditSports />
        </Route>
        <Route path={`${props.match.path}/sports/edit-sports/:id`} >
          <EditSports />
        </Route>
        <Route path={`${props.match.path}/classifieds`}>
          <Classifieds />
        </Route>
        <Route path={`${props.match.path}/individual-registrations`}>
          <IndvRegistrations />
        </Route>
        <Route path={`${props.match.path}/league/:seasonId`} exact>
          <League {...props} />
        </Route>
        <Route path={`${props.match.path}/sms-settings`} exact>
          <SmsSettings {...props} />
        </Route>
        <Route path={`${props.match.path}/ViewChampions`}>
          <TeamInfo />
        </Route>
        <Route path={`${props.match.path}/LeagueChampions`}>
          <LeagueChampion />
        </Route>
        <Route path={`${props.match.path}/LeagueGroups`} exact>
          <LeagueGroups />
        </Route>
        <Route path={`${props.match.path}/LeagueGroups/TeamInfo/:league_id/:id`} exact>
          <TeamInfo />
        </Route>
        <Route path={`${props.match.path}/individual-registrations/TeamInfo/:league_id/:id`} exact>
          <TeamInfo backLink={`${props.match.path}/individual-registrations`} from='individual_registration' />
        </Route>
        <Route path={`${props.match.path}/LeagueGroups/TeamInfo/add/:league_id/:id/`}>
          <AddPlayer />
        </Route>
        <Route path={`${props.match.path}/individual-registrations/TeamInfo/add/:league_id/:id/`}>
          <AddPlayer from='individual-registrations' />
        </Route>
        <Route path={`${props.match.path}/teams`}>
          <LeagueGroups />
        </Route>
        <Route path={`${props.match.path}/champions`} exact>
          <ViewChampions />
        </Route>
        <Route path={`${props.match.path}/champions/team/:id`} exact>
          <LeagueChampion />
        </Route>
        <Route path={`${props.match.path}/schedule`}>
          <CreateSchedule />
        </Route>
        <Route path={`${props.match.path}/level-of-play`}>
          <LevelOfPlay />
        </Route>
      </div>
    </div>
  </>
}

export default withRouter(Leagues);